import PropTypes from 'prop-types';

const DashIcon = ({ size = '24', color = '#000', white }) => {
  let iconColor = color;
  if (white) {
    iconColor = '#fff';
  }

  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <rect width="14" height="2" x="5" y="11" fill={iconColor} rx="1" />
      </g>
    </svg>
  );
};

DashIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
};

export default DashIcon;
